import { render, staticRenderFns } from "./adminEditor.pug?vue&type=template&id=1732ce96&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./adminEditor.scss?vue&type=style&index=0&id=1732ce96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1732ce96",
  null
  
)

export default component.exports